import { http, onSuccess, onFail } from "./http";

export const getEventModuleTheme = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/module/theme`)
        .then(onSuccess, onFail);

export const getEventModuleSettings = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/module/settings`)
        .then(onSuccess, onFail);

export const updateEventModuleTheme = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/theme`, data)
        .then(onSuccess, onFail);

export const updateEventModuleSettings = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/settings`, data)
        .then(onSuccess, onFail);

export const updateEventModuleBranding = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/branding`, data)
        .then(onSuccess, onFail);

export const updateEventModuleEpisode = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/episode`, data)
        .then(onSuccess, onFail);

export const updateEventModuleComment = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/comment`, data)
        .then(onSuccess, onFail);

export const updateEventModuleQuestion = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/question`, data)
        .then(onSuccess, onFail);

export const updateEventModuleActivity = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/activity`, data)
        .then(onSuccess, onFail);

export const updateEventModuleInformation = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/information`, data)
        .then(onSuccess, onFail);

export const updateEventModulePage = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/page`, data)
        .then(onSuccess, onFail);

export const updateEventModuleMain = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/main`, data)
        .then(onSuccess, onFail);

export const updateEventModuleQuiz = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/quiz`, data)
        .then(onSuccess, onFail);

export const updateEventModuleShop = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/module/shop`, data)
        .then(onSuccess, onFail);
